<template>
  <div class="w-full bg-primary flex justify-between items-center border-b-[2px] border-primarySelect">
    <div 
      class="w-full flex justify-between items-center pt-[5px] pb-[5px]"
      :class="{ 'pl-[40px] pr-[40px]': !isMobile, 'pl-[20px] pr-[20px]': isMobile }">
      
      <div class="flex items-center gap-3">
        <BackButton
          v-if="
            isMobile &&
            ($route.name == 'editor' ||
              ($route.name == 'book' && $store.getters.bookLeftBarFolded))
          "
        />
        <EpisodLogo/>
        <div
          v-if="
            $route.name == 'book' ||
            $route.name == 'recommend' ||
            $route.name == 'editor' ||
            $route.name == 'revision'
          "
        >
          <div class="flex justify-start items-center relative">
            <div
              class="flex justify-center items-center w-[64px] h-[37px] relative gap-1.5 rounded-lg hover:bg-primaryHover cursor-pointer"
              @click="handleBookShelfClick"
            >
              <p
                class="flex-grow-0 flex-shrink-0 text-[13px] font-bold text-left text-textPrimary"
              >
                나의 책장
              </p>
            </div>
            <svg
              v-if="$route.name == 'editor' || $route.name == 'revision'"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
              preserveAspectRatio="none"
            >
              <path
                d="M8.78032 8.00047L5.95188 5.17203C5.69153 4.91168 5.69153 4.48956 5.95188 4.22921C6.21223 3.96887 6.63434 3.96887 6.89468 4.22922L9.95881 7.29336C10.3493 7.68388 10.3493 8.31705 9.95881 8.70757L6.89468 11.7717C6.63433 12.032 6.21223 12.032 5.95188 11.7717C5.69153 11.5113 5.69153 11.0892 5.95188 10.8289L8.78032 8.00047Z"
                fill="#CDCDCD"
              ></path>
            </svg>
            <div
              v-if="$route.name == 'editor' || $route.name == 'revision'"
              :class="[
                'flex justify-center items-center w-[77px] h-[37px] relative gap-1.5 rounded-lg hover:bg-primaryHover',
                !creatingBook ? 'cursor-pointer' : 'cursor-wait',
              ]"
              @click="!creatingBook ? handleEditorClick() : null"
            >
              <p
                class="w-[80%] text-[13px] font-medium text-left text-[#474747] truncate"
              >
                {{ showMainChapterTitle }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="screenWidthOverLarge" class="flex justify-center items-center"> 
        <div class="flex justify-center items-center h-[14px] gap-[50px]">
          <ServiceGuide/>
          <CustomerServiceButton
            @click="handleCustomerServiceClick" />
          <OpenKakaoButton
            @click="handleCommunicateButtonClick"
          />
        </div>
      </div>
      <div v-else class="flex-1"></div> <div class="flex items-center gap-5">
        <UndoRedoButton
          v-if="
            $route.name == 'editor' && !showPrintModal && screenWidthOverMaximum
          "
        />
        <LoginButton
          v-if="$route.name == 'home'"
          @click="handleLoginClick">
        </LoginButton>
        <NextStepButton
          v-if="
            ($route.name == 'book' && !isMobile) ||
            $route.name == 'recommend' ||
            ($route.name == 'editor' && !isMobile) ||
            $route.name == 'revision'
          "
          :button-name="buttonName"
          @click="handleButtonClick"
        />
        <ExportModal
          v-if="isExportBannerDropOpen"
          class="fixed"
          @close-modal="closeDropdown"
        />
        <MakeBookButton
          v-if="!isMobile && $route.name == 'editor'"
          :style="{
            'pointer-events': disableMakeBookButton ? 'none' : 'auto',
          }"
          @click="handleMakeBook"
        />
        <RevisionCloseModal
          v-if="showRevisionCloseModal"
          @close-modal="handleCloseRevisionModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NextStepButton from '@/components/Top/NextStepButton.vue'
// import ProgressBar from '@/components/Top/ProgressBar.vue'
import UndoRedoButton from '@/components/Top/UndoRedoButton.vue'
import EpisodLogo from '@/components/Top/EpisodLogo.vue'
import MakeBookButton from '@/components/Top/MakeBookButton.vue'
import RevisionCloseModal from '@/components/Top/RevisionCloseModal.vue'
import CustomerServiceButton from '@/components/Top/CustomerServiceButton.vue'
import BackButton from '@/components/Top/BackButton.vue'
import { RevisionStatus } from '@/store/constants/revisionStatus'
import ExportModal from '@/components/Top/ExportModal.vue'
import OpenKakaoButton from '@/components/Top/OpenKakaoButton.vue'
import ServiceGuide from '@/components/Top/ServiceGuide.vue'
import LoginButton from '@/components/Top/LoginButton.vue'

export default {
  components: {
    OpenKakaoButton,
    ExportModal,
    NextStepButton,
    // ProgressBar,
    UndoRedoButton,
    EpisodLogo,
    MakeBookButton,
    RevisionCloseModal,
    CustomerServiceButton,
    BackButton,
    ServiceGuide,
    LoginButton,
  },
  data() {
    return {
      lastScrollY: 0,
      isBannerVisible: true,
      scrollThreshold: 80,

      KAKAO_URL: 'https://pf.kakao.com/_MuhQG/chat',
      KAKAO_OPEN_CHAT_URL: 'https://open.kakao.com/o/gsHleNRg',
      screenWidth: window.innerWidth,
      disableMakeBookButton: false,
      creatingBook: false,
      isExportBannerDropOpen: false,
    }
  },
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode
    },
    revisionResult() {
      return this.$store.getters.revisionResult
    },
    showMainChapterTitle() {
      let title = this.$store.getters.currentBook.book_schema.main_chapter.title
      if (title.length === 0) return '제목없음'
      return title
    },
    buttonName() {
      if (this.$route.name === 'home') {
        return '로그인/회원가입'
      } else if (this.$route.name === 'book') {
        return '책 만들기'
      } else if (this.$route.name === 'recommend') {
        if (this.$store.getters.recommendProcess < 3) {
          return '건너뛰기'
        }
        return '목차 구성'
      } else if (this.$route.name === 'editor') {
        if (this.$store.getters.showPrintModal) {
          return '내보내기'
        }
        return '퇴고하기'
      } else if (this.$route.name === 'revision') {
        return '일괄 반영'
      }
      return null
    },
    showRevisionCloseModal() {
      return this.$store.getters.showRevisionCloseModal
    },
    showPrintModal() {
      return this.$store.getters.showPrintModal
    },
    screenWidthOverMaximum() {
      // return this.screenWidth > 939
      return this.screenWidth > 1164
    },
    screenWidthOverLarge() {
      return this.screenWidth > 800
    },
    isMobile() {
      return this.screenWidth < 640
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.lastScrollY = window.scrollY; // Initialize with current scroll position
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    document.addEventListener('keydown', this.closeDropdown)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('keydown', this.closeDropdown)
  },
  methods: {
    handleToggleDarkMode() {
      if (this.isDarkMode) {
        this.$store.commit('SET_DARK_MODE', false)
      } else {
        this.$store.commit('SET_DARK_MODE', true)
      }
    },
    handleScroll() {
      if (this.isMobile) {
        return;
      }
      const currentScrollY = window.scrollY;

      if (currentScrollY <= this.scrollThreshold) {
        // Near the top or scrolled up within threshold, always show
        this.isBannerVisible = true;
      } else if (currentScrollY > this.lastScrollY) {
        // Scrolling down
        this.isBannerVisible = false;
      } else if (currentScrollY < this.lastScrollY) {
        // Scrolling up
        this.isBannerVisible = true;
      }
      // Store the current scroll position for the next event.
      // Ensure lastScrollY doesn't go negative on bounce scrolling (iOS/macOS).
      this.lastScrollY = currentScrollY <= 0 ? 0 : currentScrollY;
    },
    handleResize() {
      this.screenWidth = window.innerWidth
    },
    handleTitleClick() {
      if (this.$route.name === 'revision') {
        this.$store.commit('SET_SHOW_REVISION_CLOSE_MODAL', 1)
        return
      }
      if (this.$route.name === 'recommend') {
        this.$store.commit('SET_SHOW_RECOMMEND_CLOSE_MODAL', 2)
        return
      }
      if (this.$store.getters.isLoggedIn) {
        this.$router.push({ name: 'book' })
        return
      }
      this.$router.push({ name: 'home' })
    },
    handleBookShelfClick() {
      if (this.$route.name === 'revision') {
        this.$store.commit('SET_SHOW_REVISION_CLOSE_MODAL', 1)
        return
      }
      if (this.$route.name === 'recommend') {
        this.$store.commit('SET_SHOW_RECOMMEND_CLOSE_MODAL', 2)
        return
      }
      this.$router.push({ name: 'book' })
    },
    async handleEditorClick() {
      if (this.$route.name === 'revision') {
        this.$store.commit('SET_SHOW_REVISION_CLOSE_MODAL', 2)
        return
      }
      if (this.$route.name === 'recommend') {
        if (this.$store.getters.recommendProcess < 3) {
          this.$store.commit('SET_SHOW_RECOMMEND_CLOSE_MODAL', 1)
          return
        }
        this.sendGtagEvent('recommend_step_3', {
          total_section_count: this.$store.getters.totalSectionCount,
          total_deleted_section_count: this.$store.getters.deletedSectionCount,
          accept_rate:
            this.$store.getters.totalSectionCount === 0
              ? 0
              : (this.$store.getters.totalSectionCount -
                  this.$store.getters.totalDeleteSectionCount) /
                this.$store.getters.totalSectionCount,
        })
        if (this.creatingBook) return
        this.creatingBook = true
        await this.$store.dispatch('createPageByBookSchema')
        setTimeout(() => {
          this.creatingBook = false
        }, 2000)
        this.$router.push({ name: 'editor' })
        this.$store.commit('NEXT_RECOMMEND_PROCESS')
        return
      }
      this.$router.push({ name: 'editor' })
    },
    handleCustomerServiceClick() {
      window.open(this.KAKAO_URL, '_blank', 'noopener,noreferrer')
    },
    handleCommunicateButtonClick() {
      window.open(this.KAKAO_OPEN_CHAT_URL, '_blank', 'noopener,noreferrer')
    },
    handleLoginClick() {
      this.$router.push({ name: 'book' })
    },
    async handleButtonClick() {
      if (this.$route.name === 'book') {
        if (this.creatingBook) return
        this.creatingBook = true
        await this.$store.dispatch('createNewBook')
        this.$store.commit('RESET_RECOMMEND_PROCESS')
        setTimeout(() => {
          this.creatingBook = false
        }, 2000)
        this.$router.push({ name: 'recommend' })
      } else if (this.$route.name === 'recommend') {
        if (this.$store.getters.recommendProcess < 3) {
          this.$store.commit('SET_SHOW_RECOMMEND_CLOSE_MODAL', 1)
          return
        }
        this.sendGtagEvent('recommend_step_3', {
          total_section_count: this.$store.getters.totalSectionCount,
          total_deleted_section_count: this.$store.getters.deletedSectionCount,
          accept_rate:
            this.$store.getters.totalSectionCount === 0
              ? 0
              : (this.$store.getters.totalSectionCount -
                  this.$store.getters.totalDeleteSectionCount) /
                this.$store.getters.totalSectionCount,
        })
        if (this.creatingBook) return
        this.creatingBook = true
        try {
          await this.$store.dispatch('createPageByBookSchema')
        } catch (error) {
          this.$store.commit(
            'SET_ERROR_MESSAGE',
            '목차 구성 중 오류가 발생했습니다.'
          )
          this.$store.commit('SET_SHOW_ERROR_MODAL', true)
        }
        setTimeout(() => {
          this.creatingBook = false
        }, 2000)
        this.$router.push({ name: 'editor' })
        this.$store.commit('NEXT_RECOMMEND_PROCESS')
      } else if (this.$route.name === 'editor') {
        if (this.$store.getters.showPrintModal) {
          this.openDropdown()
          // window.print()
        } else {
          if (!this.$store.getters.currentPageID) {
            this.$store.commit(
              'SET_REVISION_STATE',
              RevisionStatus.NO_PAGE_SELECTED
            )
            return
          }
          if (this.isMobile) {
            this.$store.commit(
              'SET_REVISION_STATE',
              RevisionStatus.MOBILE_NOT_SUPPORTED
            )
            return
          }
          this.$store.commit('SET_REVISION_STATE', RevisionStatus.LLM_REQUESTED)
        }
      } else if (this.$route.name === 'revision') {
        const fixTags = document.querySelectorAll('fix')
        for (let index = 0; index < this.revisionResult.length; index++) {
          if (!this.revisionResult[index].handled) {
            this.$gtag.event('revision-selection', {
              'revision-selected': 'approve',
              'original-text': this.revisionResult[index].originalText,
              'revised-text': this.revisionResult[index].revisedText,
            })
            this.$store.dispatch('storeRevisionData', {
              originalText: this.revisionResult[index].originalText,
              revisedText: this.revisionResult[index].revisedText,
              isRevised: true,
            })
            fixTags[index].childNodes[3].classList.remove('unfixed', 'focused')
            fixTags[index].childNodes[3].innerText =
              this.revisionResult[index].revisedText
            fixTags[index].childNodes[1].remove()
            this.revisionResult[index].handled = true
          }
        }
        this.$store.commit('SET_REVISION_STATE', RevisionStatus.USER_CHECK_DONE)
      } else {
        this.$router.push({ name: 'book' })
      }
    },
    handleCloseRevisionModal() {
      this.$store.commit('SET_SHOW_REVISION_CLOSE_MODAL', 0)
    },
    handleMakeBook() {
      if (this.disableMakeBookButton) return
      if (this.$store.getters.saveForPrint) {
        this.$store.commit('SET_SAVE_FOR_PRINT', false)
      }
      this.disableMakeBookButton = true
      setTimeout(() => {
        this.disableMakeBookButton = false
      }, 1000)

      if (this.$store.getters.showPrintModal) {
        this.$store.commit('SET_SHOW_PRINT_MODAL', false)
        return
      }
      // If no editor component rendered to listen, force show print modal
      if (!this.$store.getters.currentPageID) {
        this.$store.commit('SET_SAVE_FOR_PRINT', false)
        this.$store.commit('SET_SHOW_PRINT_MODAL', true)
        return
      }

      this.$store.commit('SET_SAVE_FOR_PRINT', true)
      setTimeout(() => {
        this.$store.commit('SET_SHOW_PRINT_MODAL', true)
      }, 100)
    },
    sendGtagEvent(eventName, eventParams) {
      this.$gtag.event(eventName, eventParams)
    },
    openDropdown() {
      this.isExportBannerDropOpen = true
    },
    closeDropdown() {
      this.isExportBannerDropOpen = false
    },
  },
}
</script>
